import React from "react";
import { Container } from "@material-ui/core";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { ABOUT_US_LINK, CONVERTOR_HOME_PAGE_LINK, COMPRESSOR_HOME_PAGE_LINK, CONVERTOR_FORM_PAGE_LINK, COMPRESSOR_FORM_PAGE_LINK } from "./constants/routingLinks";
import AboutUs from "./Components/AboutUs/AboutUs";
import Home from "./Components/Home/Home";
import ConvertorHomePage from "./Components/Home/ConvertorHomePage/ConvertorHomePage";
import ConvertorForm from "./Components/Home/ConvertorHomePage/ConvertorForm/ConvertorForm";
import CompressorHomePage from "./Components/Home/CompressorHomePage/CompressorHomePage";
import CompressorForm from "./Components/Home/CompressorHomePage/CompressorForm/CompressorForm";
import PageNotFound from "./Components/PageNotFound/PageNotFound";

const App = () => {
    return (
        <BrowserRouter>
            <Container maxwidth="lg">
                <Navbar />
                <Switch>
                    <Route path="/" exact><Home /></Route>
                    <Route path={ABOUT_US_LINK} exact><AboutUs /></Route>
                    <Route path={CONVERTOR_HOME_PAGE_LINK} exact><ConvertorHomePage /></Route>
                    <Route path={COMPRESSOR_HOME_PAGE_LINK} exact><CompressorHomePage /></Route>
                    <Route path={CONVERTOR_FORM_PAGE_LINK} exact><ConvertorForm /></Route>
                    <Route path={COMPRESSOR_FORM_PAGE_LINK} exact><CompressorForm /></Route>
                    <Route path="*"><PageNotFound /></Route>
                </Switch>
            </Container>
       </BrowserRouter>
    )
}

export default App
